// Generated by CoffeeScript 2.7.0
var SettingsTab;

export default SettingsTab = Vue.extend({
  props: {
    activeTab: {
      type: String,
      default: 'basic'
    }
  },
  template: `<div class="settings-tab tabs">
  <div class="tab-navs reverse nav">
    <a  v-for="(value, key) in tabs"
        :href='parseUrl(key)'
        :class="tabClass(key)">{{ value }}</a>
  </div>
</div>`,
  data: function() {
    return {
      tabs: Skylark.Helpers.translate('settings.namespace_settings_tab')
    };
  },
  methods: {
    parseUrl: function(key) {
      return Skylark.Helpers.UrlHelper.adminUrlFor(key.replace('__', '/'));
    },
    tabClass: function(key) {
      return {
        'nav-item': true,
        active: key.replace('settings__', '') === this.activeTab
      };
    }
  }
});
